import { BlockContent, IWeekOption } from "@chef/feature-sanity";

interface WeeklyCampaignProps {
  promotions?: IWeekOption[];
}

export const WeeklyCampaign = ({ promotions }: WeeklyCampaignProps) => {
  if (!promotions) {
    return null;
  }

  return promotions.map((p) => (
    <div key={p._id} className="col-span-full">
      {p?.content && (
        <BlockContent body={p.content} prose={{ padding: "none" }} />
      )}
    </div>
  ));
};
